import { Site } from './site.entity';
import { Business } from '../business/business.entity';

export class SiteUtils {

	public static isFreeTrialForBusinessEnabled(business: Business, site?: Site){
		const siteToCheck = site || business?.site;
		if (!siteToCheck) {
			console.debug('Cannot check free trial for business, site is not defined');
			return false;
		}
		return this.isFreeTrialEnabled(siteToCheck.settings?.freeTrialEnabled, business?.country, siteToCheck.settings?.freeTrialRegions);
	}

	public static isFreeTrialEnabled(freeTrialEnabled: boolean, businessRegion: string,  freeTrialRegions?: string[]){
		if(!freeTrialEnabled) {
			return false;
		}

		if (!freeTrialRegions?.length) {
			return true;
		}

		return freeTrialRegions.includes(businessRegion);

	}
}
